import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Textarea Component - Global UI Typography Rules
 * 
 * Per Global UI & Layout Enforcement:
 * - Input Text: 12px
 * - Touch targets MUST be ≥ 48px on mobile
 */
export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // Input Text: 12px per Global UI Typography Rules
          // Updated: slate borders, refined focus ring
          "flex min-h-[100px] sm:min-h-[80px] w-full rounded-lg border border-border bg-background px-3 py-3 sm:py-2 ui-input-text ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 transition-colors",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
